
    <br/>
    <div class="responsiveFlex">
        <mat-card class="cardProfile">
            <app-personal-data [personalData]="personalData" (onSubmitPersonalEvent)='onSubmitPersonal($event)'></app-personal-data>
        </mat-card>
        <mat-card class="cardProfile">
            <app-contact-data [contactData]="contactData" (onSubmitContactEvent)='onSubmitContact($event)'></app-contact-data>
        </mat-card>
        <mat-card class="cardProfile">
            <app-physiological-data [physiologicalData]="physiologicalData" (onSubmitPhysiologicalEvent)='onSubmitPhysiological($event)'></app-physiological-data>
        </mat-card>
        <!-- <mat-card class="cardProfile">
            <app-domicile-data [domicileData]="domicileData" (onSubmitDomicileEvent)='onSubmitDomicile($event)'></app-domicile-data>
        </mat-card> -->
        <mat-card class="cardProfile">
            <app-bank-data [alumnosDatosBancario]="alumnosDatosBancario" (onSubmitBankEvent)='onSubmitBank($event)'></app-bank-data>
        </mat-card>
        
    </div>